import { CRM_PIPELINE_API } from 'modules/crm/api/crm-pipeline-api'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useDeletePipeline = () => {
  const { fetcher } = useFetch({
    method: RequestMethodsEnum.delete,
  })
  return {
    deletePipeline: (id: number) => fetcher(`${CRM_PIPELINE_API}/${id}`),
  }
}
